// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resources[data-v-e247b734]{display:flex;flex-direction:row;justify-content:space-between}.resources>*[data-v-e247b734]{width:30%}", ""]);
// Exports
module.exports = exports;
